import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { pagePath } from '../utils/consts/pagePath';

const CatalogPage = lazy(() => import('../../view/pages/CatalogPage'));

export const catalogRoutes: RouteObject = {
  path: pagePath.catalog.list,
  children: [
    {
      index: true,
      element: <CatalogPage />,
    },
  ],
};
